<script>
  import _ from 'lodash'
  import VueTypes from 'vue-types'
  import ThemeQuestionsForm from '../components/theme-questions-form'

  const _onFormChange = _.throttle((form, callee) => {
    window.app.onFormChange(form, callee)
  }, 1000)

  export default {
    template: '#theme-questions-sidebar-template',
    name: 'ThemeQuestionsSidebar',
    components: {
      'theme-questions-form': ThemeQuestionsForm,
    },
    props: {
      initThemeQuestionsFormIndex: VueTypes.number.def(0),
      initOutputType: VueTypes.string
    },
    data () {
      return {
        themeQuestionsFormIndex: this.initThemeQuestionsFormIndex,
        outputType: this.initOutputType,
        inputCompleted: true,
      }
    },
    methods: {
      onFormChange (form) {
        _onFormChange(form, this)
      },
      checklistError(inputCompleted) {
        this.inputCompleted = inputCompleted
      },
      setTitle(title) {
        this.$refs["checklist-form"].title = title
      }
    },
    watch: {
      themeQuestionsFormIndex: {
        immediate: true
      },
      outputType: {
        immediate: true
      },
      inputCompleted: {
        immediate: true
      }
    }
  }

</script>
